var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKigHat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 59,
    viewBox: "0 0 63 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2852"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.3656 16.1072C12.3612 16.3872 12.0469 19.1172 12.0469 19.1172L17.682 18.8512C17.682 18.8512 22.4689 14.0055 23.5897 14.0173C31.3524 14.1091 28.5568 9.7482 28.5568 5.31199C28.5568 -4.49709 12.4469 10.9343 12.3634 16.1048L12.3656 16.1072Z",
    fill: "#313132",
    stroke: "#1A1818",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M50.8147 16.0511C50.8191 16.2738 50.9251 17.1671 51.0422 18.2127C51.2366 19.9569 45.3211 18.6417 45.3211 18.6417C45.3211 18.6417 40.6338 13.9576 39.5316 13.9693C31.7297 14.0607 34.5394 9.71657 34.5394 5.29973C34.5394 -4.47171 50.7307 10.9005 50.8147 16.0511Z",
    fill: "#313132",
    stroke: "#1A1818",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M53.758 29.8942C52.0632 15.9748 42.9037 6.11719 31.5458 6.11719C20.1879 6.11719 11.0283 15.9748 9.33351 29.8942L8.04688 50.1172L31.4947 42.7819L55.0469 50.1172L53.7602 29.8942H53.758Z",
    fill: "#313132",
    stroke: "#1A1818",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M34.0469 6.11719H29.0469V44.1172H34.0469V6.11719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M31.5469 6.11719V6.11719V44.1172V44.1172V6.11719Z",
    stroke: "#1A1818",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M61.0469 57.1172H2.04688C2.04688 40.1008 10.1988 22.1172 31.5989 22.1172C52.9991 22.1172 61.0469 40.0985 61.0469 57.1172Z",
    fill: "#313132",
    stroke: "#1A1818",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKigHat);
export default __webpack_public_path__ + "static/media/kigHat.d5f9bd4a6163622b0cf56210bb546030.svg";
export { ForwardRef as ReactComponent };